import {z} from '@hono/zod-openapi';

/** Complete source identifiers only. Dealer coefficients are never part of this response. */
export const hondaDiscountGroupsResponseSchema = z
  .object({
    groups: z
      .array(z.object({id: z.string().uuid(), code: z.string().trim().min(1).max(100)}))
      .min(1)
      .max(1000),
  })
  .openapi('HondaDiscountGroupsResponse');
